import Constants from "~/helpers/enums/Constants";

const initialState = {
	contract: null,
};

const contractReducer = (state = initialState, action = null) => {
	switch (action.type) {
		case Constants.GET_CONTRACT:
			return {
				...state,
				contract: action.payload.contract,
			};
		default:
			return state;
	}
};

export default contractReducer;